<template>
    <el-dialog title="编辑分类" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form" ref="form">

            <el-form-item label="所属分类" :label-width="formLabelWidth">
                <el-select v-model="form.parent_id">
                <el-option label="顶级分类" :value="0"></el-option>
                <el-option
                    v-for="cate in editform.cateList"
                    :value="cate.category_id"
                    :label="cate.name"
                    :key="cate.categoty_id"
                ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分类名称" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="分类图片" :label-width="formLabelWidth">
                <el-row>
                <el-button type="primary" @click="openUpload">选择图片</el-button>
                <div v-if="form.image_id != ''" class="img">
                    <img :src="file_path" width="100" height="100" />
                </div>
                </el-row>
            </el-form-item>

            <el-form-item label="显示方式" :label-width="formLabelWidth">
                <el-radio-group v-model="form.show_type.id">
                <el-radio :label="0">默认</el-radio>
                <el-radio :label="1">瀑布流</el-radio>
                </el-radio-group>
            </el-form-item> 
            
            <el-form-item label="是否显示在手机端" :label-width="formLabelWidth">
            <el-radio-group v-model="form.is_show">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">不显示</el-radio>
            </el-radio-group>
        </el-form-item>

            <el-form-item label="排序" :label-width="formLabelWidth">
                <el-input type="number" v-model="form.sort" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editCategory" :loading="loading">确 定</el-button>
        </div>

        <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc" >上传图片</Upload>

    </el-dialog>
</template>

<script>
    import ArticleApi from '@/api/article.js';
    import Upload from "@/components/file/Upload";

    export default {
         components: {
            Upload,
        },

        data() {
            return {
                form: {
                    parent_id: "0",
                    category_id: "0",
                    name: "",
                    sort: 0,
                    image_id: 0,
                    show_type: "",
                    is_show:1,
                },                
                file_path: "",
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogVisible: false,
                loading: false,
                /*是否上传图片*/
                isupload: false,
            };
        },
        props: ['open_edit', 'editform'],
        created() {
            this.dialogVisible = this.open_edit;
            console.log(this.editform)
            this.form = this.editform.model;           
            this.getImage(this.editform.model.category_id);
        },
        methods: {
            /*修改分类*/
            editCategory() {
                let self = this;
                let params = this.form;
                params.show_type = this.form.show_type.id;
                self.loading = true;
                ArticleApi.editCategory(params, true)
                    .then(data =>
                    {
						self.loading = false;
                        self.$message({
                            message: '恭喜你，修改成功',
                            type: 'success'
                        });
                        self.dialogFormVisible(true);

                    })
                    .catch(error =>
                    {
						self.loading = false;
                    });
            },

            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            },
            
            /*获取图片 */
            getImage(category_id) {
            ArticleApi.cateImage(
                {
                category_id: category_id,
                },
                true
            )
                .then((data) => {
                console.log(data);
                this.form.image_id = data.data.detail.image_id;
                this.file_path = data.data.detail.images.file_path;
                })
                .catch((error) => {});
            },

            /*上传*/
            openUpload(e) {
            this.type = e;
            this.isupload = true;
            },
            
            /*获取图片*/
            returnImgsFunc(e) {
            if (e != null && e.length > 0) {
                this.file_path = e[0].file_path;
                this.form.image_id = e[0].file_id;
            }
            this.isupload = false;
            },            

        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/article/category/part/Edit.vue